module.exports = __webpack_public_path__ + "7b4785ccf670dc8503df7ef6b19ae998.pdf";